import { addEventLog } from 'utils/functions/eventLogFunctions';
import USBToast from '../../components/toast/usb';

interface DeviceSignals {
	platform: string;
	renderer: string;
	hasTouch: boolean;
	hasPen: boolean;
}

function getDeviceSignals(): DeviceSignals {
	const canvas = document.createElement('canvas');
	const gl = canvas.getContext('webgl') as WebGLRenderingContext | null;
	const debugInfo = gl?.getExtension('WEBGL_debug_renderer_info');
	const renderer = debugInfo
		? (gl!.getParameter(debugInfo.UNMASKED_RENDERER_WEBGL) as string)
		: '';

	return {
		platform: navigator.platform || '',
		renderer,
		hasTouch: navigator.maxTouchPoints > 0,
		hasPen: 'PointerEvent' in window,
	};
}
function isUnsupportedSystem(signals: DeviceSignals): boolean {
	const renderer = signals.renderer.toLowerCase();
	const platform = signals.platform.toLowerCase();

	const gpuMatch =
		renderer.includes('iris xe') ||
		renderer.includes('surface') ||
		(renderer.includes('intel') && renderer.includes('graphics'));

	const isWindows = platform.includes('win');
	const isTouchWindows = isWindows && signals.hasTouch;

	return (gpuMatch && isTouchWindows) || !isWindows;
}

function isBrowserUnsupported(signals: DeviceSignals): boolean {
	const platform = signals.platform.toLowerCase();
	const isWindows = platform.includes('win');
	const isChromium = navigator.userAgent.includes("Chrome");

	return !(isChromium && isWindows);
}

function getBrowserLabel(): string {
	const ua = navigator.userAgent;
	if (ua.includes('Edg/')) return 'Edge';
	if (ua.includes('OPR/')) return 'Opera';
	if (ua.includes('Firefox/')) return 'Firefox';
	if (ua.includes('Chrome/')) return 'Chrome';
	if (ua.includes('Safari/')) return 'Safari';
	return ua;
}

function formatSystemSignals(signals: DeviceSignals): string {
	return [
		`Renderer: ${signals.renderer || 'N/A'}`,
		`Has Touch: ${signals.hasTouch}`,
	].join(', ');
}

function formatBrowserSignals(): string {
	return `User Agent: ${navigator.userAgent}`;
}

export function checkSystemSupport(userId: number | undefined): boolean {
	const signals = getDeviceSignals();

	if (isUnsupportedSystem(signals)) {
		USBToast('Unsupported System', 'This site may not work correctly on your device. If you encounter issues please refresh the page and try again, or use another Windows PC or mobile device.', 'system-not-supported-message', false);
		addEventLog(
			'System Check Failure - Unsupported',
			'System Support Check',
			0,
			'',
			`User Id: ${userId || 'N/A'}, Platform: ${signals.platform}, ${formatSystemSignals(signals)}`
		);
	}
	if (isBrowserUnsupported(signals)) {
		USBToast('Unsupported Browser', 'This site may not work correctly in your browser. For the best experience, please use a Chromium-based browser', 'browser-not-supported-message', false);
		addEventLog(
			'Browser Check Failure - Unsupported',
			'System Support Check',
			undefined,
			undefined,
			`User id: ${userId || 'N/A'}, Browser: ${getBrowserLabel()}, Platform: ${signals.platform}, ${formatBrowserSignals()}`
		);
	}
	return isUnsupportedSystem(signals) || isBrowserUnsupported(signals);
}